(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elizzee-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('elizzee-newsletter-popup')) {
    customElements.define(
      'elizzee-newsletter-popup',
      class ElizzeeNewsletterPopup extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.panel = this.querySelector('[data-popup-panel]');
          this.closeButton = this.querySelector('[data-popup-close]');
          this.delaySeconds = Math.max(0, Number(this.dataset.delay) || 0);
          this.hideDays = Math.max(1, Number(this.dataset.hideDays) || 1);
          this.isDesignMode = this.dataset.designMode === 'true';
          this.isEnabled = this.dataset.enabled === 'true';
          this.formHasState = Boolean(this.querySelector('[data-popup-form-state]'));
          this.handleClose = () => this.hide();
          this.handleKeydown = (event) => {
            if (event.key === 'Escape') this.hide();
          };
          this.handleSectionSelect = (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.show();
          };

          this.closeButton?.addEventListener('click', this.handleClose);
          document.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('shopify:section:select', this.handleSectionSelect);

          if (this.formHasState || (this.isDesignMode && this.isEnabled)) {
            this.show();
            return;
          }

          if (!this.isEnabled || !this.canShow()) return;

          this.timer = window.setTimeout(() => this.show(), this.delaySeconds * 1000);
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          this.closeButton?.removeEventListener('click', this.handleClose);
          document.removeEventListener('keydown', this.handleKeydown);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        }

        canShow() {
          try {
            const dismissedAt = Number(localStorage.getItem(this.dataset.storageKey));
            const hiddenFor = this.hideDays * 24 * 60 * 60 * 1000;
            return !dismissedAt || Date.now() - dismissedAt > hiddenFor;
          } catch {
            return true;
          }
        }

        show() {
          window.clearTimeout(this.timer);
          this.hidden = false;
          window.requestAnimationFrame(() => {
            this.dataset.visible = 'true';
            this.panel?.focus({ preventScroll: true });
          });
        }

        hide() {
          this.dataset.visible = 'false';

          if (!this.isDesignMode) {
            try {
              localStorage.setItem(this.dataset.storageKey, String(Date.now()));
            } catch {}
          }

          window.setTimeout(() => {
            if (this.dataset.visible !== 'true') this.hidden = true;
          }, 230);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarMarquee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      const track = this.querySelector('.announcement-bar__track');
      const original = this.querySelector('.announcement-bar__group');

      if (!track || !original || !original.children.length) return;

      const duplicate = original.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.inert = true;
      duplicate.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      duplicate.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.tabIndex = -1;
      });

      track.appendChild(duplicate);
      this.dataset.ready = 'true';
    }
  }

  if (!customElements.get('announcement-bar-marquee')) {
    customElements.define('announcement-bar-marquee', AnnouncementBarMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
